import * as React from "react";
import {KpiStructure} from "benchmarking-domain/kpi-definition";
import {useCallback, useState} from "react";
import {JsonEditor} from "components/core/json-editor";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import * as KpiStructureSchema from "benchmarking-domain/schemas/kpi-structure.schema.json";

interface KpiStructureFormProps {
  kpiStructure?: KpiStructure;
  onSubmit: (data: KpiStructure) => Promise<void>;
}

export function KpiStructureForm({kpiStructure, onSubmit}: KpiStructureFormProps): React.JSX.Element {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [jsonObject, setJsonObject] = useState<{}>({...kpiStructure});

  const jsonChangeHandler = useCallback((data: any) => {
    setJsonObject(data);
  }, []);

  const submitChanges = useCallback(async () => {
    setIsSaving(true);
    try {
      await onSubmit(jsonObject as KpiStructure);
    } finally {
      setIsSaving(false);
    }
  }, [onSubmit, jsonObject])

  return (
    <Card sx={{overflow: "visible"}}>
      <CardHeader title="Kpi structure"/>
      <Divider/>
      <CardContent>
        <JsonEditor json={kpiStructure} schema={KpiStructureSchema} onChangeJson={jsonChangeHandler} />
      </CardContent>
      <Divider/>
      <CardActions sx={{justifyContent: 'flex-end'}}>
        <Button onClick={submitChanges} variant="contained" disabled={isSaving}>Save details</Button>
      </CardActions>
    </Card>

  );
}
